var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57741 6.91083C3.90284 6.58539 4.43048 6.58539 4.75592 6.91083L9.99999 12.1549L15.2441 6.91083C15.5695 6.58539 16.0971 6.58539 16.4226 6.91083C16.748 7.23626 16.748 7.7639 16.4226 8.08934L10.5893 13.9227C10.2638 14.2481 9.73618 14.2481 9.41074 13.9227L3.57741 8.08934C3.25197 7.7639 3.25197 7.23626 3.57741 6.91083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownWhite);
export default __webpack_public_path__ + "static/media/down_white.55a78b56aec92f8dc95fc81a53cf73dd.svg";
export { ForwardRef as ReactComponent };